package com.example.monetix.utils

import kotlin.math.roundToLong

fun parseEuroToCents(input: String): Long {
    val s = input.trim().replace(',', '.')
    if (s.isBlank()) return 0L
    return if (s.contains('.')) {
        ((s.toDoubleOrNull() ?: 0.0) * 100.0).roundToLong()
    } else {
        (s.toLongOrNull() ?: 0L) * 100L
    }
}

fun formatEuroFromCents(cents: Long, bool: Boolean): String {
    val isNegative = cents < 0
    val absCents = if (isNegative) -cents else cents
    val euros = absCents / 100
    val remainder = absCents % 100
    val centsString = remainder.toString().padStart(2, '0')

    // 🔥 AGGIUNTA: Formatta gli euro interi con i puntini delle migliaia (es. 1.500.000)
    val eurosString = euros.toString().reversed().chunked(3).joinToString(".").reversed()

    val sign = if (isNegative) "-" else ""
    return "$sign$eurosString,$centsString €"
}

fun normalizeEuroInput(input: String): String {
    val normalized = input.replace('.', ',')
    return buildString {
        var commaSeen = false
        normalized.forEach { ch ->
            when {
                ch.isDigit() -> append(ch)
                ch == ',' && !commaSeen -> {
                    append(ch)
                    commaSeen = true
                }
            }
        }
    }
}